type BBBSealSize = "small" | "default" | "large";

export default function BBBTrust({ size = "default" }: { size?: BBBSealSize }) {
    const sealMap = {
        small: {
            src: "https://seal-seflorida.bbb.org/frame/blue-seal-200-42-whitetxt-bbb-92054732.png?chk=6964174B51",
            width: 200,
            height: 42,
        },
        default: {
            src: "https://seal-seflorida.bbb.org/frame/blue-seal-250-52-bbb-92054732.png?chk=6964174B51",
            width: 250,
            height: 52,
        },
        large: {
            src: "https://seal-seflorida.bbb.org/frame/blue-seal-280-80-bbb-92054732.png?chk=6964174B51",
            width: 280,
            height: 80,
        },
    };

    const seal = sealMap[size];

    return (
        <section className="bg-[#0b1220] py-10 border-t border-white/10">
            <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-center gap-6">

                {/* Seal container stays white for contrast */}
                <div
                    className="rounded-md bg-white p-2 shadow-sm"
                    style={{
                        width: seal.width + 8,
                        height: seal.height + 10,
                        overflow: "hidden",
                        lineHeight: 0,
                    }}
                >
                    <iframe
                        title="BBB Accredited Business Seal"
                        src={seal.src}
                        width={seal.width}
                        height={seal.height}
                        scrolling="no"
                        frameBorder={0}
                        loading="lazy"
                        style={{ border: 0, display: "block" }}
                    />
                </div>

                <div className="max-w-xl text-gray-300 text-sm text-center md:text-left">
                    <strong className="text-white">BBB Accredited Business</strong>{" "}
                    with an <strong className="text-white">A- rating</strong>. Secure ID
                    Technologies of Florida LLC is committed to ethical business practices
                    and transparency.
                </div>
            </div>
        </section>
    );
}
